import slick from '@accessible360/accessible-slick';

export const PXBadgeSlider = (function () {
	'use strict';

	function init() {
		events();
	}

	function events() {
		if ($(".badge--info-yes")[0]) {
			var slides = 4;
			var mobile = slides - 3;
			var tablet = slides - 1;
			$('.badges').slick({
				dots: false,
				arrows: true,
				speed: 200,
				autoplay: false,
				slidesToShow: slides,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							dots: true,
							arrows: false,
							slidesToShow: tablet,
							slidesToScroll: tablet,
							infinite: true,
						},
				},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: mobile,
							slidesToScroll: mobile,
							infinite: true,
							dots: true,
							arrows: false,
						},
				},
			],
			});

		} else {

			$('.badges').slick({
				dots: false,
				arrows: true,
				speed: 200,
				autoplay: false,
				slidesToShow: 5,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							dots: true,
							arrows: false,
							slidesToShow: 4,
							slidesToScroll: 4,
							infinite: true,
						},
				},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
							infinite: true,
							dots: true,
							arrows: false,
						},
				},
			],
			});

		}

		$('.badge').click(function () {
			$(this).children('.badge--info').toggleClass('badge-active');
		});
	}

	return {
		init: init,
	};
})();
